import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { ApiResource } from './../../../models/api-resource.interface';
import { BulkImportUser, User } from './../../users/user.interface';
import { UserService } from './user.service';
const service = new UserService();

export interface UserState {
   usersOverview?: ApiResource<Array<User>>;
}

const UserStore: Module<UserState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_USERS_OVERVIEW(state, usersOverview?: ApiResource<Array<User>>) {
         state.usersOverview = usersOverview;
      },
      ADD_USER(state, user: User) {
         state.usersOverview?.data.push(user);
      },
      DELETE_USER(state, userId: number) {
         const index = (state.usersOverview?.data || []).findIndex((u) => u.id === userId);
         if (index > -1) state.usersOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async getUsers(context, payload: { tenantId: number; query?: LocationQuery }) {
         const response = await service.getUsers(payload.tenantId, payload.query);
         context.commit('SET_USERS_OVERVIEW', response);
         return response;
      },
      async createUser(context, payload: { tenantId: number; user: User }) {
         const response = await service.postUser(payload.tenantId, payload.user);
         context.commit('ADD_USER', response);
         return response;
      },
      async deleteUser(context, payload: { tenantId: number; userId: number }) {
         const response = await service.deleteUser(payload.tenantId, payload.userId);
         context.commit('DELETE_USER', payload.userId);
         return response;
      },
      async userBatch(context, payload: { tenantId: number; users: Array<BulkImportUser> }) {
         const response = await service.userBatch(payload.tenantId, payload.users);
         context.commit('batch/ADD_BATCH', response, { root: true });
         return response;
      },
   },
};

export default UserStore;
